var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLinkLgUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2169_678)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12.4458,
    r: 9,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.0001,
    cy: 12.4458,
    r: 7.5,
    fill: "#F7DE2A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.786 14.8473L13.1941 9.97192H15.1847C16.3412 9.97192 16.8036 10.652 16.5255 11.615C16.2435 12.5914 15.3781 13.2581 14.2075 13.2581H13.2963L12.8373 14.8473H11.786ZM13.5317 12.4433H14.2746C14.8985 12.4433 15.2971 12.1066 15.4391 11.615C15.5791 11.1302 15.373 10.8002 14.7492 10.8002H14.0062L13.5317 12.4433Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5677 9.97192H12.6261L11.712 13.1368C11.4027 14.2075 10.3574 14.9146 9.09578 14.9146C7.83414 14.9146 7.20426 14.2075 7.5135 13.1368L8.42761 9.97192H9.47898L8.58821 13.056C8.42679 13.615 8.72168 14.0257 9.35251 14.0257C9.99034 14.0257 10.5155 13.615 10.6769 13.056L11.5677 9.97192Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0599 2.44695C11.2969 2.28461 8.52481 2.19332 7.16769 2.12891L8.16306 2.90298L8.55928 3.20595L8.69478 3.15167C9.44319 2.63297 11.25 2.46573 12.0599 2.44695Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0001 3.69643C7.16795 3.69643 3.25075 7.61363 3.25075 12.4457C3.25075 12.7909 2.97095 13.0707 2.6258 13.0707C2.28065 13.0707 2.00085 12.7909 2.00085 12.4457C2.00085 6.92333 6.47765 2.44653 12.0001 2.44653C12.3452 2.44653 12.625 2.72633 12.625 3.07148C12.625 3.41663 12.3452 3.69643 12.0001 3.69643Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0017 21.0804C16.8338 21.0804 20.751 17.1632 20.751 12.3311C20.751 11.986 21.0308 11.7062 21.3759 11.7062C21.7211 11.7062 22.0009 11.986 22.0009 12.3311C22.0009 17.8535 17.5241 22.3303 12.0017 22.3303C11.6565 22.3303 11.3767 22.0505 11.3767 21.7054C11.3767 21.3602 11.6565 21.0804 12.0017 21.0804Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9418 22.3297C12.7049 22.492 15.4769 22.5833 16.834 22.6477L15.8387 21.8736L15.4425 21.5707L15.307 21.6249C14.5585 22.1436 12.7517 22.3109 11.9418 22.3297Z",
    fill: "#222222"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2169_678"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.443359)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLinkLgUp);
export default __webpack_public_path__ + "static/media/icon_link_lg_up.07aafdb4c1549f7396562bb34720c390.svg";
export { ForwardRef as ReactComponent };